import { flow, types } from "mobx-state-tree"
import Api from '../api/Api'
import State, {pending, error, done, notLoaded} from './State'
import PaginationResponse from './PaginationResponse'

export const Transaction = types.model({
    id: types.number,
    from_location: types.frozen(),
    location: types.frozen(),
    from_user: types.frozen(),
    user: types.frozen(),
    weight: types.number,
    campaign_prefix: types.string,
    token: types.string,
    created_at: types.string,
    pallet_size: types.number,
    delivered_at: types.maybeNull(types.string),
    next: types.maybeNull(types.number),
    previous: types.maybeNull(types.number)
})

const TransactionStore = types.model({
    transactions: types.maybe(PaginationResponse(Transaction)),
    transactionsState: types.optional(State, notLoaded),
})
.actions(self => ({
    fetchAccountTransactions: flow(function* fetchAccountTransactions(accountId, rowsPerPage, page) {
        self.transactions = undefined;
        self.transactionsState = pending
        try {
            const response = yield Api.get(`/inventory_transactions/?chain__account=${accountId}&limit=${rowsPerPage}&offset=${page*rowsPerPage}`)
            self.transactions = response.data
            self.transactionsState = done
        } catch (e) {
            console.error(e)
            self.transactionsState = error
        }
    }),
    fetchCustomerTransactions: flow(function* fetchCustomerTransactions(customerId, rowsPerPage, page) {
        self.transactions = undefined;
        self.transactionsState = pending
        try {
            const response = yield Api.get(`/inventory_transactions/?location__customer=${customerId}&limit=${rowsPerPage}&offset=${page*rowsPerPage}`)
            self.transactions = response.data
            self.transactionsState = done
        } catch (e) {
            console.error(e)
            self.transactionsState = error
        }
    }),
    fetchTokenTransactions: flow(function* fetchTokenTransactions(token, campaignPrefix, rowsPerPage, page) {
        self.transactions = undefined;
        self.transactionsState = pending
        try {
            const response = yield Api.get(`/inventory_transactions/?chain__token=${token}&chain__campaign_prefix=${campaignPrefix}&limit=${rowsPerPage}&offset=${page*rowsPerPage}`)
            self.transactions = response.data
            self.transactionsState = done
        } catch (e) {
            console.error(e)
            self.transactionsState = error
        }
    }),
    fetchInventoryLocationTransactions: flow(function* fetchInventoryLocationTransactions(inventoryLocationId, rowsPerPage, page) {
        self.transactions = undefined;
        self.transactionsState = pending
        try {
            const response = yield Api.get(`/inventory_transactions/?location=${inventoryLocationId}&limit=${rowsPerPage}&offset=${page*rowsPerPage}`)
            self.transactions = response.data
            self.transactionsState = done
        } catch (e) {
            console.error(e)
            self.transactionsState = error
        }
    }),
}))
export default TransactionStore.create({})


// WEBPACK FOOTER //
// ./src/stores/TransactionStore.js